import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, message, Row } from 'antd';
import { productDelete } from 'api/product_sdk';

import { Button, Modal } from 'ui-kit';
import { useOwnerDetails } from 'api/owners';
import { useSignedUser } from 'api/auth';

import './DeleteModal.scss';

const DeleteModal = ({ isOpen, onCancel, afterClose, onDeleteProduct, product }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { data: user } = useSignedUser();
  const { invalidate } = useOwnerDetails(user?.owner_id);

  const deleteProductMask = {
    background: 'rgba(245, 238, 249, 0.5)',
    backdropFilter: 'blur(15px)',
  };

  const handleConfirmDelete = () => {
    setIsLoading(true);

    productDelete({
      productId: product.id,
    })
      .then(() => {
        invalidate();
        message.success('Product has been removed successfully!');
        onDeleteProduct();
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        message.error('An error occurred while removing a product! Please try again later.');
      });
  };

  const handleCancel = useCallback(() => {
    if (!isLoading) {
      onCancel();
    }
  }, [isLoading, onCancel]);

  return (
    <div className="Modal_container">
      <Modal
        maskClosable={false}
        className="DeleteModal"
        title="Delete Product"
        visible={isOpen}
        onCancel={handleCancel}
        afterClose={afterClose}
        maskStyle={deleteProductMask}
        footer={
          <div className="Modal_footer">
            <Row>
              <Col xs={24} align="center">
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleConfirmDelete}
                  loading={isLoading}
                >
                  Yes, delete this product
                </Button>
              </Col>
              <Col xs={24} align="center">
                <Button onClick={handleCancel} disabled={isLoading}>
                  No, take me back
                </Button>
              </Col>
            </Row>
          </div>
        }
      >
        <Row>
          <Col>
            <p>
              By continuing, you’ll delete the product “{product?.name}”, which can’t be undone.
            </p>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

DeleteModal.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  afterClose: PropTypes.func,
  onDeleteProduct: PropTypes.func,
  product: PropTypes.object,
};

DeleteModal.defaultProps = {
  onAfterClose: () => null,
};

export default DeleteModal;
